import React from "react"
import Navbar from "../layout/Navbar/Navbar"
import Footer from "../layout/Footer/Footer"




export default function AppLayout(props) {
    return (
        <div>
            <Navbar/>
            {props.children}
            <Footer/>
        </div>
    )
}